import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Cornerstone spike: acts on the item chosen in a <cs-dropdown>. cs-dropdown-item has no
// href, so each item carries what it does:
//   data-href="/path"   Turbo visit. Add data-href-frame="frame-id" to load it into that
//                       turbo-frame (data-href-action="advance" to put it in the address
//                       bar too), or data-href-target="_blank" to open a new tab instead.
//                       A download (.csv, .json) needs nothing more: Turbo hands a URL with
//                       one of its unvisitableExtensions straight to the browser, which saves
//                       the file and stays on the page.
//   data-peek="item-id" open that work item in the peek, on the page you're on: this page's
//                       URL with ?peek=item-id, loaded into #peek_panel and put in the address
//                       bar. Built here, not on the server, because a row's menu is fetched
//                       from work_items#actions_menu (FD-428), which can't know whether the
//                       menu sits on a list, a board, a sprint, an epic or a view (FD-1296).
//                       A page with no peek (a work item's own page, where its sub-items
//                       have this menu) uses the item's data-href instead.
//   data-form="form-id" submit that form (a hidden button_to, so non-GET requests keep
//                       the CSRF token and the _method override; see MenuHelper)
//                       Add data-form-field="name" data-form-value="v" to set that field of the
//                       form first, so one form serves a list of choices rather than a form
//                       (and a CSRF token) per choice (FD-494), and data-form-confirm="…" to
//                       ask first (Turbo's data-turbo-confirm, set on the form for this submit).
//   data-open-dialog="dialog-id"
//                       open that <cs-dialog>
//   anything else       a `menu:select` event is dispatched on the item, so the item can
//                       run another controller's action: data-action="menu:select->theme#toggle"
// data-keep-open on an item leaves the menu open after it is picked, for an item whose
// feedback shows in the item itself (the work item menu's Copy items say "Copied!").
// cs-select fires for mouse and keyboard picks alike, which a click-> action on the item
// would not. Wire it as data-controller="menu-actions" data-action="cs-select->menu-actions#select".
export default class extends Controller {
  select(event) {
    const item = event.detail?.item
    if (!item) return
    if (item.hasAttribute("data-keep-open")) event.preventDefault()

    const { peek, href, hrefFrame, hrefAction, hrefTarget, form, formField, formValue, formConfirm, openDialog } = item.dataset
    if (peek && document.getElementById("peek_panel")) {
      const url = new URL(window.location.href)
      url.searchParams.set("peek", peek)
      Turbo.visit(url.toString(), { frame: "peek_panel", action: "advance" })
    } else if (href && hrefTarget) {
      window.open(href, hrefTarget, "noopener")
    } else if (href) {
      // A frame that isn't on the page makes Turbo visit the whole page instead.
      Turbo.visit(href, hrefFrame ? { frame: hrefFrame, action: hrefAction } : {})
    } else if (form) {
      const formElement = document.getElementById(form)
      if (!formElement) return
      if (formField) {
        const field = formElement.elements.namedItem(formField)
        if (field) field.value = formValue ?? ""
      }
      if (formConfirm) formElement.dataset.turboConfirm = formConfirm
      formElement.requestSubmit()
    } else if (openDialog) {
      const dialog = document.getElementById(openDialog)
      if (dialog) dialog.open = true
    } else {
      item.dispatchEvent(new CustomEvent("menu:select", { bubbles: true }))
    }
  }
}
